import React, { useState } from 'react';
import { MdOutlineCancel, MdLock, MdLockOpen } from 'react-icons/md';
import { BiShow, BiHide } from 'react-icons/bi'; 
import { useStateContext } from '../../contexts/ContextProvider';
import { ButtonSubmit, FooterPages } from '..';
import { useUsuarioMutations } from '../../hooks/usuarios/useUsuarioMutations'
import { fetchUser } from '../../utils/fetchUser';

const initialState = { 
  passwordActual: '', 
  passwordNueva: '', 
  confirmPasswordNueva: '' 
};

const CambioPassword = () => {
  const { currentColor, isClicked, setIsClicked } = useStateContext();
  const userInfo = fetchUser();
  
  const [formData, setFormData] = useState(initialState);
  const [showPassword, setShowPassword] = useState({
    actual: false,
    nueva: false,
    confirm: false
  });
  const [mensajeError, setMensajeError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { updatePasswordUsuarioS } = useUsuarioMutations();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    if (mensajeError) setMensajeError('');
  };

  const toggleShowPassword = (field) => {
    setShowPassword(prev => ({
      ...prev,
      [field]: !prev[field]
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMensajeError('');
    setIsSubmitting(true);

    // Validaciones
    if (!formData.passwordActual) {
      setMensajeError('Debe ingresar la contraseña actual!');
      setIsSubmitting(false);
      return;
    }
    
    if (!formData.passwordNueva) {
      setMensajeError('Debe ingresar la nueva contraseña!');
      setIsSubmitting(false);
      return;
    }
    
    if (!formData.confirmPasswordNueva) {
      setMensajeError('Debe confirmar la nueva contraseña!');
      setIsSubmitting(false);
      return;
    }
    
    if (formData.confirmPasswordNueva !== formData.passwordNueva) {
      setMensajeError('Las contraseñas no coinciden!');
      setIsSubmitting(false);
      return;
    }
    
    if (formData.passwordActual === formData.passwordNueva) {
      setMensajeError('La nueva contraseña debe ser diferente a la actual!');
      setIsSubmitting(false);
      return;
    }

    try {
      const usuarioData = {
        usuario: userInfo.usuario, 
        passwordActual: formData.passwordActual,
        passwordNueva: formData.passwordNueva, 
        confirmPasswordNueva: formData.confirmPasswordNueva 
      };

      await updatePasswordUsuarioS.mutateAsync(usuarioData);
      setIsClicked(!isClicked.passwordusuario);
      setFormData(initialState);
    } catch (error) {
      setMensajeError('Error al cambiar la contraseña. Intente nuevamente.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
      <form 
        autoComplete="off" 
        onSubmit={handleSubmit}
        className="bg-white dark:bg-gray-800 rounded-xl shadow-2xl w-full max-w-md mx-4"
      >
        <div className="p-6">
          {/* Encabezado */}
          <div className="flex justify-between items-center mb-6">
            <div className="flex items-center gap-3">
              <div className="bg-blue-100 p-3 rounded-full">
                <MdLock className="text-blue-600 text-2xl" />
              </div>
              <div>
                <p className="font-bold text-xl text-gray-800 dark:text-white">Cambiar Contraseña</p>
                <p className="text-xs text-gray-500">Protege tu cuenta con una contraseña segura</p>
              </div>
            </div>
            <button
              type="button"
              onClick={() => setIsClicked(!isClicked.passwordusuario)}
              className="text-gray-500 hover:text-gray-700 dark:hover:text-gray-300 transition-colors"
            >
              <MdOutlineCancel className="text-2xl" />
            </button>
          </div>

          {/* Mensaje de error */}
          {mensajeError && (
            <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg">
              <p className="text-red-600 text-sm font-medium">{mensajeError}</p>
            </div>
          )}

          {/* Campos del formulario */}
          <div className="space-y-4">
            {/* Contraseña actual */}
            <div className="relative">
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                Contraseña Actual
              </label>
              <div className="relative">
                <input
                  className={`w-full px-4 py-3 text-sm border ${
                    mensajeError && !formData.passwordActual 
                      ? 'border-red-300' 
                      : 'border-gray-300'
                  } rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400 transition-all`}
                  type={showPassword.actual ? 'text' : 'password'}
                  placeholder="Ingresa tu contraseña actual"
                  required
                  name="passwordActual"
                  value={formData.passwordActual}
                  onChange={handleChange}
                />
                <button 
                  type="button" 
                  onClick={() => toggleShowPassword('actual')}
                  className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-500 hover:text-gray-700"
                >
                  {showPassword.actual ? <BiHide size={18} /> : <BiShow size={18} />}
                </button>
              </div>
            </div>

            {/* Nueva contraseña */}
            <div className="relative">
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                Nueva Contraseña
              </label>
              <div className="relative">
                <input
                  className={`w-full px-4 py-3 text-sm border ${
                    mensajeError && !formData.passwordNueva 
                      ? 'border-red-300' 
                      : 'border-gray-300'
                  } rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400 transition-all`}
                  type={showPassword.nueva ? 'text' : 'password'}
                  placeholder="Crea una nueva contraseña"
                  required
                  name="passwordNueva"
                  value={formData.passwordNueva}
                  onChange={handleChange}
                />
                <button 
                  type="button" 
                  onClick={() => toggleShowPassword('nueva')}
                  className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-500 hover:text-gray-700"
                >
                  {showPassword.nueva ? <BiHide size={18} /> : <BiShow size={18} />}
                </button>
              </div>
            </div>

            {/* Confirmar nueva contraseña */}
            <div className="relative">
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                Confirmar Nueva Contraseña
              </label>
              <div className="relative">
                <input
                  className={`w-full px-4 py-3 text-sm border ${
                    mensajeError && (formData.confirmPasswordNueva !== formData.passwordNueva || !formData.confirmPasswordNueva)
                      ? 'border-red-300' 
                      : 'border-gray-300'
                  } rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400 transition-all`}
                  type={showPassword.confirm ? 'text' : 'password'}
                  placeholder="Confirma tu nueva contraseña"
                  required
                  name="confirmPasswordNueva"
                  value={formData.confirmPasswordNueva}
                  onChange={handleChange}
                />
                <button 
                  type="button" 
                  onClick={() => toggleShowPassword('confirm')}
                  className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-500 hover:text-gray-700"
                >
                  {showPassword.confirm ? <BiHide size={18} /> : <BiShow size={18} />}
                </button>
              </div>
            </div>

            {/* Consejos para contraseña segura */}
            <div className="bg-blue-50 p-3 rounded-lg border border-blue-100">
              <p className="text-xs text-blue-700 font-medium mb-1">Consejos para una contraseña segura:</p>
              <ul className="text-xs text-blue-600 list-disc pl-5 space-y-1">
                <li>Usa al menos 8 caracteres</li>
                <li>Combina letras, números y símbolos</li>
                <li>Evita información personal fácil de adivinar</li>
              </ul>
            </div>
          </div>

          {/* Botón de envío */}
          <div className="mt-2">
            <ButtonSubmit
              color="white"
              bgColor={currentColor}
              text={isSubmitting ? "Procesando..." : "Cambiar Contraseña"}
              borderRadius="10px"
              width="full"
              disabled={isSubmitting}
              icon={isSubmitting ? null : <MdLockOpen className="ml-2" />}
            />
          </div>
        </div>
        
      </form>
    </div>
  );
}

export default CambioPassword;